import { call, put, takeLatest } from 'redux-saga/effects';
import { decryptRequestURL, getHTMLDetail, updateHTMLDetail, getHTMLTemplate } from './api';
import {
  DECRYPT_URL_REQUEST,
  DECRYPT_URL_SUCCESS,
  DECRYPT_URL_FAILURE,
  FETCH_HTML_REQUEST,
  FETCH_HTML_SUCCESS,
  FETCH_HTML_FAILURE,
  FETCH_TEMPLATE_REQUEST,
  FETCH_TEMPLATE_SUCCESS,
  FETCH_TEMPLATE_FAILURE,
  UPDATE_HTML_REQUEST,
  UPDATE_HTML_SUCCESS,
  UPDATE_HTML_FAILURE
} from './constants';

/**
 * Decrypt Request URL
 */
function* decryptURL(action) {
  try {
    const decrypted = yield call(decryptRequestURL, action.payload.request);
    if (action.payload.successCallback) {
      action.payload.successCallback(decrypted.data);
    }
    yield put({ type: DECRYPT_URL_SUCCESS });
  } catch (e) {
    console.log(e.response || e);
    yield put({
      type: DECRYPT_URL_FAILURE,
      appError: {
        status: e.response ? e.response.status : null,
        statusText: e.response ? e.response.statusText : '',
        data: {
          message: e.response ? e.response.data.message || e.response.data.error : e.message
        }
      }
    });
  }
}

/**
 * Fetch HTML detail
 */
function* fetchHTMLDetail(action) {
  try {
    const htmlDetail = yield call(getHTMLDetail, action.payload.contentID);
    if (action.payload.successCallback) {
      action.payload.successCallback(htmlDetail);
    }
    yield put({ type: FETCH_HTML_SUCCESS, html: htmlDetail });
  } catch (e) {
    console.log(e.response || e);
    yield put({
      type: FETCH_HTML_FAILURE,
      appError: {
        status: e.response ? e.response.status : null,
        statusText: e.response ? e.response.statusText : '',
        data: {
          message: e.response ? e.response.data.message || e.response.data.error : e.message
        }
      }
    });
  }
}

/**
 * Update HTML detail
 */
function* updateHTML(action) {
  try {
    // Update HTML detail
    const htmlDetail = yield call(updateHTMLDetail, action.payload);
    yield put({ type: UPDATE_HTML_SUCCESS, html: htmlDetail });
  } catch (e) {
    console.log(e.response || e);
    yield put({
      type: UPDATE_HTML_FAILURE,
      appError: {
        status: e.response ? e.response.status : null,
        statusText: e.response ? e.response.statusText : '',
        data: {
          message: e.response ? e.response.data.message || e.response.data.error : e.message
        }
      }
    });
  }
}

/**
 * Fetch HTML template
 */
function* fetchTemplate(action) {
  try {
    const template = yield call(getHTMLTemplate, action.payload.url);
    yield put({ type: FETCH_TEMPLATE_SUCCESS, templateString: template });
  } catch (e) {
    console.log(e.response || e);
    yield put({
      type: FETCH_TEMPLATE_FAILURE,
      appError: {
        status: e.response ? e.response.status : null,
        statusText: e.response ? e.response.statusText : '',
        data: {
          message: e.response ? e.response.data.message || e.response.data.error : e.message
        }
      }
    });
  }
}

function* htmlSaga() {
  yield takeLatest(DECRYPT_URL_REQUEST, decryptURL);
  yield takeLatest(FETCH_HTML_REQUEST, fetchHTMLDetail);
  yield takeLatest(UPDATE_HTML_REQUEST, updateHTML);
  yield takeLatest(FETCH_TEMPLATE_REQUEST, fetchTemplate);
}

export default htmlSaga;



// WEBPACK FOOTER //
// ./src/containers/html/saga.js